module.exports = __webpack_public_path__ + "static/media/muavin.04b4bca8.svg";